// HttpOnly only applies to server Set-Cookie; tokens here stay readable for X-AUTH-TOKEN in api.js.
export function setCookie(cname, cvalue, exhrs) {
  var hours = typeof exhrs === 'number' && !isNaN(exhrs) ? exhrs : 8;
  var d = new Date();
  d.setTime(d.getTime() + hours * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  var secure = typeof window !== 'undefined' && window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;SameSite=Lax' + secure;
}

export function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      let cookie = c.substring(name.length, c.length);
      return cookie;
    }
  }
  return '';
}

export function isWebView() {
  return navigator.userAgent.toLowerCase().indexOf('mobile') !== -1;
}
